import { IAppState } from '../../../AppModulesWrapper';

import { selectLocationIds } from './selectLocationIds';

export const selectRegionId = (state: IAppState) => {
  const locationIds = selectLocationIds(state);

  return locationIds[0];
};
